<template>
  <div>
    <v-card>
      <v-card-text>
        <DateTimePicker
          @getDateFrom="dateFrom = $event"
          @getDateTo="dateTo = $event"
        ></DateTimePicker>

        <v-row v-if="!$checkRole('ADVERTISERS') && !$checkRole('ADVERTISERS_USERS') && !$checkRole('PROVIDERS')">
          <v-col
            cols="6"
            xl="6"
            md="6"
            sm="12"
          >
            <autocomplete-with-session-update
              v-model="advertiserId"
              :items="advertisers"
              item-text="name"
              item-value="id"
              :label="$t('Advertiser')"
              :disabled="loadingFirst"
              clearable
              hide-details
              session-storage-key="advertiserId"
            ></autocomplete-with-session-update>
          </v-col>
          <v-col
            cols="1"
            xl="1"
            md="1"
            m="1"
          >
            <v-progress-circular
              v-if="loadingFirst"
              class="mt-5"
              indeterminate
              color="primary"
              :width="2"
              :size="20"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <br>
        <v-row>
          <v-col
            cols="6"
            xl="6"
            md="6"
            sm="12"
          >
            <autocomplete-with-session-update
              ref="camp"
              v-model="campaignId"
              :items="campaigns"
              item-text="name"
              item-value="id"
              :label="$t('CampaignFilter')"
              :disabled="loadingCampaign"
              hide-details
              session-storage-key="campaignId"
            ></autocomplete-with-session-update>
          </v-col>
          <v-col
            cols="1"
            xl="1"
            md="1"
            sm="1"
          >
            <v-progress-circular
              v-if="loadingCampaign"
              class="mt-5"
              indeterminate
              color="primary"
              :width="2"
              :size="20"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <br>
        <v-row>
          <v-col
            cols="6"
            xl="6"
            md="6"
            sm="12"
          >
            <v-combobox
              v-model="select"
              :items="items"
              item-text="providerName"
              item-value="providerId"
              :label="$t('ProviderElements.SelectProvider')"
              :disabled="loadingProviders"
              multiple
              hide-selected
            >
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                  v-if="item === Object(item)"
                  v-bind="attrs"
                  :input-value="selected"
                  label
                  small
                >
                  <span class="pr-2">{{ item.providerName }}</span>
                  <v-icon
                    small
                    @click="parent.selectItem(item)"
                  >
                    $delete
                  </v-icon>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-col
            cols="1"
            xl="1"
            md="1"
            sm="1"
          >
            <v-progress-circular
              v-if="loadingProviders"
              class="mt-5"
              indeterminate
              color="primary"
              :width="2"
              :size="20"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <br>

        <v-btn
          color="primary"
          @click="getDataFromDB"
        >
          {{ $t('BtnSearch') }}
        </v-btn>
      </v-card-text>
    </v-card>
    <br>
    <div>
      <v-data-table
        :headers="getHeaders"
        :items="dataFromDb"
        item-key="name"
        class="elevation-1"
        :sort-by.sync="orderBy"
        :sort-desc.sync="sortDesc"
        :search="search"
        :loading="loading"
        :locale="$i18n.locale"
      >
        <template v-slot:top>
          <div class="row">
            <div class="col-8">
              <div class="container">
                <v-btn
                  v-if="$checkAbility('CAN_DOWNLOAD_REPORT')"
                  outlined
                  color="primary"
                  @click="exportToExcel()"
                >
                  {{ $t('VtrReportElements.Download') }}
                </v-btn>
              </div>
            </div>
            <div class="col-4">
              <v-text-field
                v-model="search"
                :label="$t('LblSearch')"
                class="mx-4"
              ></v-text-field>
            </div>
          </div>
        </template>
        <template v-slot:item.bounce="{ item }">
          {{ item.bounce }}%
        </template>
      </v-data-table>
    </div>
    <v-snackbar
      v-model="showMessage"
      :timeout="timeout"
      color="error"
    >
      {{ messageText }}
    </v-snackbar>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import qs from 'qs';
import AutocompleteWithSessionUpdate from '../Components/AutocompleteWithSessionUpdate.vue';
import DateTimePicker from '../Components/DateTimePicker.vue';

export default {
  setup() {
    const select = ref()
    const items = []

    return { select, items }
  },
  components: {
    DateTimePicker,
    AutocompleteWithSessionUpdate,
  },
  data() {
    return {
      orderBy: 'providerName',
      sortDesc: false,
      advertisers: [],
      advertiserId: Number(sessionStorage.getItem('advertiserId')) || null,
      campaigns: [],
      loadingCampaign: false,
      loadingProviders: false,
      loadingFirst: false,
      showMessage: false,
      costModel: 'cpc',
      messageText: '',
      campaignId: Number(this.$route.params.campaign_id) || Number(sessionStorage.getItem('campaignId')),
      timeout: 5000,
      search: '',
      dataFromDb: [],
      json_fields: {},
      dateFrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1,
        new Date().getHours(),
        new Date().getMinutes(),
        new Date().getSeconds(),
      )
        .toISOString()
        .substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      loading: false,
      headers: [],
      countVisits: 0,
      items: [],
    }
  },
  computed: {
    getHeaders() {
      return this.headers
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.getDataFromDB()
    },
    advertiserId() {
      this.getCampaigns(false)
    },
    campaignId() {
      this.getProviders()
    },
  },
  mounted() {
    this.firstLoad()
  },
  methods: {
    exportToExcel() {
      let cols = [
        { width: 25 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
      ]

      this.$exportToExcel(
        this.headers,
        this.dataFromDb,
        `${this.$t('ProvidersExcelHeader')}.xlsx`,
        `${this.$t('ProvidersExcelHeader')}`,
        cols,
      )
    },
    firstLoad() {
      this.getAdvertisers().then(() => {
        this.getCampaigns(true).then(() => {
          this.getDataFromDB()
        })
      })
    },

    getAdvertisers() {
      this.loadingFirst = true

      return this.$http
        .get(`/publisher/filter/adv-users`, { params: { userId: this.$getUserId() } })
        .then(response => {
          this.advertisers = response.data

          if (this.firstLoad === true) {
            this.advertiserId = null
          }

          this.loadingFirst = false
        })
    },

    getCampaigns(isFirstLoad) {
      this.loadingCampaign = true

      return this.$http
        .get(`/campaigns/filter/campaigns`, {
          params: { userId: this.$getUserId(), advertiserId: this.advertiserId },
        })
        .then(response => {
          this.campaigns = response.data !== null ? response.data : []
          if (isFirstLoad) {
            if (!this.campaignId) {
              if (this.campaigns.length > 0) {
                this.campaignId = this.campaigns[0].id
              } else {
                this.campaignId = null
              }
            }
          } else if (this.campaigns.length > 0) {
            this.campaignId = this.campaigns[0].id
          } else {
            this.campaignId = null
          }

          this.loadingCampaign = false

          this.getProviders()
        })
        .catch(error => {
          // TODO: Next Update - Show notification
          this.showMessage = true
          this.messageText = error
        })
    },

    getProviders() {
      this.loadingProviders = true
      this.select = null

      const params = {
        userId: this.$getUserId(),
        campaignIds: this.campaignId,
      }

      // this.$http.get('/providers', params)
      this.$http
        .get(
          `/campaigns/filter/traffic-providers?${qs.stringify(params, { arrayFormat: 'repeat' })}`,
        )
        .then(response => {
          this.items = response.data != null ? response.data : []
          this.loadingProviders = false
        })
        .catch(error => {
          console.log(error)
          this.loadingProviders = false
        })
    },

    getDataFromDB() {
      if (!this.campaignId) {
        this.messageText = this.$t('EmptyCampaignId')
        this.showMessage = true

        return
      }

      const currentCampaign = this.campaigns.find(e => e.id === this.campaignId)

      if (currentCampaign) {
        this.costModel = currentCampaign.сost_model_id.toUpperCase()
      }

      this.loading = true

      const dateStart = this.dateFrom != null ? `${this.dateFrom}` : '1970-01-01'
      const dateFinish = this.dateTo != null ? `${this.dateTo}` : `${new Date().toISOString().substr(0, 10)}`
      const providerId = this.select != null ? this.select.map(s => s.providerId) : null

      const params = {
        userId: this.$getUserId(),
        campaignId: this.campaignId,
        dateFrom: dateStart,
        dateTo: dateFinish,
      }

      if (providerId) {
        params.providerIds = providerId
      }

      // this.$http.get(`${Vue.prototype.$apiBaseURL}/providers?` + qs.stringify(params, { arrayFormat: 'repeat' }))
      this.$http
        .get(`/providers?${qs.stringify(params, { arrayFormat: 'repeat' })}`)
        .then(response => {
          this.dataFromDb = response.data != null ? response.data : []
          this.countVisits = 0
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.dataFromDb.length; i++) {
            this.countVisits += this.dataFromDb[i].visits
          }

          this.headers = []

          this.headers.push({ text: this.$t('ProviderElements.Provider'), value: 'providerName', isForExcel: true })
          this.headers.push({ text: this.$t('ProviderElements.Views'), value: 'views', isForExcel: true })
          this.headers.push({ text: this.$t('ProviderElements.Clicks'), value: 'clicks', isForExcel: true })
          if (this.countVisits > 0) {
            this.headers.push({ text: this.$t('ProviderElements.Visits'), value: 'visits', isForExcel: true })
          }
          if (this.$checkAbility('CAN_VIEW_CTR')) {
            this.headers.push({ text: 'CTR', value: 'ctr', isForExcel: true })
          }
          this.headers.push({ text: this.costModel, value: 'costPer', isForExcel: true })
          if (this.$checkAbility('CAN_VIEW_COST')) {
            this.headers.push({ text: this.$t('ProviderElements.Cost'), value: 'costStat', isForExcel: true })
          }
          if (this.countVisits > 0) {
            this.headers.push({ text: this.$t('ProviderElements.Bounce'), value: 'bounce', isForExcel: true })
            this.headers.push({ text: this.$t('ProviderElements.Depth'), value: 'depth', isForExcel: true })
            this.headers.push({ text: this.$t('ProviderElements.Duration'), value: 'duration', isForExcel: true })
          }

          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
  },
}
</script>
